export default __webpack_public_path__ + "static/merchant-video-poster-b6622d9bb309dc2b11169dfafff14b2a.png";